// Endorsements are stored and matched (in the report SQL) by the endorsement type's
// description, so these descriptions must not change. Types listed here are shown to
// users under a different name.
export class EndorsementTypeConstants {
    static readonly NonQualifyingLoss: string = 'Franchise loss/Non-Qualifying Loss';

    static readonly DisplayNames: { [description: string]: string } = {
        [EndorsementTypeConstants.NonQualifyingLoss]: 'Non-Qualifying Loss'
    };

    static getDisplayName(description: string | undefined): string {
        return (description && EndorsementTypeConstants.DisplayNames[description]) || description || '';
    }
}
